import { createAction, props } from '@ngrx/store';
import { IBulkImportTemplateTypes } from '../models/bulk-import-template-types.model';

export const loadBulkImportTemplateTypes = createAction(
  '[BulkImportTemplateTypes] Load BulkImportTemplateTypes',
  props<{ request: string }>()
);

export const loadBulkImportTemplateTypesSuccess = createAction(
  '[BulkImportTemplateTypes] Load BulkImportTemplateTypes Success',
  props<{ response: IBulkImportTemplateTypes[] }>()
);

export const loadBulkImportTemplateTypesFailure = createAction(
  '[BulkImportTemplateTypes] Load BulkImportTemplateTypes Failure',
  props<{ error: Error | any }>()
);
